export default function AffiliateDisclosure() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20" data-testid="affiliate-disclosure-page">
      <div className="eyebrow mb-4">Legal</div>
      <h1 className="font-serif text-5xl md:text-6xl text-forest-900 leading-tight">Affiliate Disclosure</h1>
      <div className="article-body mt-10">
        <p className="text-sm uppercase tracking-[0.28em] text-forest-500">Last Updated: May 2026</p>
        <p className="lead">
          At Githy, transparency and trust are important to us. This website may participate in various affiliate marketing programs, which means we may earn commissions on qualifying purchases made through links on this site at no additional cost to you.
        </p>

        <h2>What Are Affiliate Links?</h2>
        <p>
          Some of the links on this website are affiliate links. If you click on these links and make a purchase, we may receive a small commission from the retailer or service provider.
        </p>
        <p>
          These commissions help support the operation of this website, including content creation, research, hosting, and maintenance.
        </p>

        <h2>Our Commitment</h2>
        <p>
          We only recommend products, services, tools, and platforms that we believe may provide value to our readers. However, all opinions expressed on this website are our own.
        </p>
        <p>
          We encourage users to do their own research before making any purchasing decisions.
        </p>

        <h2>Sponsored Content</h2>
        <p>
          From time to time, this website may publish sponsored posts or promotional content. Any such content will be clearly identified as sponsored where applicable.
        </p>

        <h2>Contact</h2>
        <p>
          If you have any questions regarding this disclosure, you may contact us at <a href="mailto:contact@githy.com">contact@githy.com</a>.
        </p>
      </div>
    </div>
  );
}
